import React, { memo, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { MdKeyboardArrowLeft as ArrowLeftIcon, MdClear as ExitIcon } from 'react-icons/md';

import SearchDocs from './searchDocs.component';
import { searchForDocumentation, searchInputChanged, resetFoundDocumentation } from './store/actions';
import { searchTextSelector, isLoadingSelector, foundDocumentationSelector } from './store/selectors';
import { HelpContentPropTypes } from '../../../shared/proptypes';

import { SEARCH_DOCUMENTATION_SECTION_NAME, SEARCH_TIMEOUT_DELAY } from '../../helpMenu.constants';

const SearchDocsPage = ({
  searchText,
  searchInputChanged,
  searchForDocumentation,
  resetFoundDocumentation,
  foundDocumentation,
  isLoading,
  history,
  onClose,
}) => {
  const debouncedSearchForDocumentation = useMemo(() =>
    debounce(text => searchForDocumentation(`${text}`), SEARCH_TIMEOUT_DELAY),
  [searchForDocumentation]);

  function onSearchTextChanged(e) {
    const text = e.target.value;
    searchInputChanged(text);
    if (text) {
      debouncedSearchForDocumentation(text);
    } else {
      debouncedSearchForDocumentation.cancel();
      resetFoundDocumentation();
    }
  }

  const handleClick = useCallback(content => history.push(`/content/${content.contentId}`), [history]);

  return (
    <>
      <h4 className="popup-header">
        <div className="header">
          <div className="popup-header-back-arrow" onClick={history.goBack}>
            <ArrowLeftIcon />
          </div>
          <h5>{SEARCH_DOCUMENTATION_SECTION_NAME}</h5>
          <ExitIcon onClick={onClose} className="popup-header-exit" />
        </div>
      </h4>
      <div className="popup-body">
        <SearchDocs
          onSearchChange={onSearchTextChanged} // eslint-disable-line react/jsx-no-bind
          onClick={handleClick}
          isLoading={isLoading}
          searchText={searchText}
          searchResults={foundDocumentation}
        />
      </div>
    </>
  );
};

SearchDocsPage.propTypes = {
  searchText: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  foundDocumentation: PropTypes.arrayOf(HelpContentPropTypes).isRequired,
  searchForDocumentation: PropTypes.func.isRequired,
  searchInputChanged: PropTypes.func.isRequired,
  resetFoundDocumentation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    searchText: searchTextSelector(state),
    isLoading: isLoadingSelector(state),
    foundDocumentation: foundDocumentationSelector(state),
  };
}

export default memo(connect(
  mapStateToProps,
  {
    searchInputChanged,
    searchForDocumentation,
    resetFoundDocumentation,
  }
)(SearchDocsPage));
